<template>
  <div class="div_base">
    <div class="module">
      <Header :navIndex="1"/>
      <!--:tabBarStyle="{ color: 'white', padding: '10px',textAlign: 'center', borderBottom: 'unset' }"-->
      <a-tabs v-if="false" :default-active-key="tabActivity" tab-position="left" class="custom_tab" @change="tabCallback" :tabBarStyle="{ color: 'red', border: 0 }">
        <a-tab-pane key="0" class="hide-divider">
           <span slot="tab" class="custom_tab_panel_title"><img :src="serviceSelected" v-if="tabActivity === '0'" width="20"><img :src="serviceUnSelected" width="20" v-else> 服务信息管理</span>
          <div class="serviceInfoManage" style="position: relative;">
            <a-row class="serviceInfoManageTitle">请完善您的知识库</a-row>
            <a-row>
              <a-textarea class="custom_textarea" :placeholder="baseTip" :rows="15" :disabled="false" v-model="fileContent">
                <a-spin />
              </a-textarea>
              <a-spin v-if="loadingBase" wrapperClassName="loadingBaseClass" class="loadingBaseClass"/>
            </a-row>
            <a-row  style="text-align: left;margin: 13px 0 0 0">
              <a-icon type="exclamation-circle" theme="filled" style="color: #28E04A;font-size: 14px;" />
              <span  style="color: #28E04A;font-size: 12px;" @click="showServiceGuide">服务信息填写指南</span>
            </a-row>
            <a-row style="text-align: left">
              <span  style="font-size: 12px;font-weight: 400;color: rgba(255,255,255,0.8);line-height: 12px;">
                注：1.文件上传方式编辑知识库为全量覆盖更新，因此请确保您上传文件内容是完整的最新内容！<br/>
                2.上传文档数量仅支持1个，格式仅支持txt文档，文档内不支持图片解析。<br/>
                3.最多支持十万字，文件大小约300K
              </span>
            </a-row>
            <a-modal
              title="服务信息填写指南"
              :visible="showServiceGuideModal"
              @cancel="showServiceGuideModal = false"
              :closable="true"
              :maskClosable="true"
              class="serviceGuideModal"
              :footer="null"
              :centered="true"
            >
              <div style="font-size: 16px;font-weight: 400;color: #000000;line-height: 19px; white-space: pre-line;">
                <div style="font-weight: 600">引言 </div>
                欢迎使用私有知识库！本知识库旨在帮助您系统地整理和展示您的产品或服务信息。通过以下指南，您可以高效地整理信息，确保用户在咨询时能快速获得他们需要的信息。您可以先录入部分行业/产品/服务信息后点击知识库页面AI诊断按钮获得更具体的填写指南哦～
                <div style="font-weight: 600;margin-top: 20px">填写原则</div>
                - 精确性：确保提供的信息准确无误。
                - 用户导向：内容应从用户的角度出发，易于理解和应用。
                - 一致性：在整个文档中保持内容的统一，勿与商品链接内容等出现冲突。
                <div style="font-weight: 600;margin-top: 20px">主要内容</div>
                1. 产品/服务的详细介绍
                - 业务范围：介绍您覆盖的领域、方向、品牌和产品。例如，“我们专注于提供优质的具有成都本地特色的火锅餐饮服务。”
                - 专业度：描述您的服务时长、所获荣誉和市场口碑。如，“我们的团队拥有10年的行业经验，曾获得多个行业奖项。”
                - 竞争优势：阐述您的独特价值和特色产品。例如，“我们的服务贴心优质，食材新鲜，招牌菜涮毛肚口感风味十足。”
                - 未来规划：分享您的理想和远景。如，“我们计划在未来五年内扩展到整个华南市场。”
                2. 您对所在领域的相关看法和理解
                - 回答诸如“您认为当前市场的主要趋势是什么？”、“您如何看待竞争对手的策略？”等问题，展示您对行业的深入理解。
                - 该部分内容对用户区分您与其他同行业竞争者具有重要参考意义。
                3. 产品/服务的售后政策说明
                - 详细说明：清晰描述产品适用人群、优惠活动、使用方法、注意事项以及与其他产品的区别。例如，“本店火锅适合麻辣爱好者，生日当天半价，可提前预定包间。”
                - 退款退货政策：详细说明退款和退货的条件、流程和时限。如，“如果产品在30天内出现问题，您可以申请全额退款。”
                <div style="font-weight: 600;margin-top: 20px">其他</div>
                凡未接触过该领域的用户有可能问到的问题，您都有可能需要补充以使AI回复更精确。
                <div style="font-weight: 600;margin-top: 20px">结语</div>
                通过遵循以上指南，希望您将能够创建一个内容丰富、易于导航的私有知识库。我们期待看到您的知识库如何帮助用户更好地理解和使用您的产品或服务。

              </div>
            </a-modal>
            <a-row type="flex" style="margin: 38px 20px 8px 0">
              <a-col flex="1" style="text-align: left">
                <a-button class="btn_upload" @click="showLoginPanel" v-if="!$store.state.userAuth.haveLogin"> 尚未登录 </a-button>
                <a-upload  v-if="$store.state.userAuth.haveLogin"
                  name="file"
                  :multiple="false"
                  listType="text"
                  :file-list="fileList"
                  @change="handleFileChange"
                  :before-upload="handleBeforeUpload"
                  accept=".text,.txt"
                  :custom-request="customUpload"
                >
                  <a-button class="btn_upload"> 上传 (步骤1) </a-button>
                </a-upload>
              </a-col>
              <a-col flex="1" style="text-align: right">
                <a-button type="primary" class="btn_now"  @click="uploadFile">
                  提交 (步骤2)
                </a-button>
              </a-col>
            </a-row>
          </div>
        </a-tab-pane>
        <a-tab-pane key="1" class="hide-divider">
          <span slot="tab" class="custom_tab_panel_title"><img :src="infoSelected" v-if="tabActivity === '1'" width="20"><img :src="infoUnSelected" width="20" v-else> 产品管理</span>
          <div class="productManage">
            <a-row class="headerRow" type="flex">
              <a-col :span="18" align="start">
                <div class="project_name" style="margin-right: 5px;font-weight: 400">产品名称</div>
                <a-input class="input_project_custom project_item" v-model="productName" placeholder="请输入产品名称" style="text-align: left"></a-input>
                <a-button class="btn_query_project project_item" type="primary"  @click="queryProduct">查询</a-button>
                <a-button class="btn_reset_project project_item"  @click="queryReset">重置</a-button>
                <a-popconfirm placement="bottom" ok-text="Yes" cancel-text="No" @confirm="deleteListSure">
                  <template slot="title">
                    <p> 确认删除这 {{ selectedList.length }} 条数据吗</p>
                  </template>
                  <a-button class="btn_reset_project project_item" v-if="showDelete">删除</a-button>
                </a-popconfirm>

              </a-col>
              <a-col :span="6" align="end">
                <a-button class="btn_add_project project_item" type="primary" style="color: black;margin-right: 0" @click="addProduct">
                  <a-icon type="plus" style="font-size: 18px;"/><span style="margin-left: 0">添加产品</span>
                </a-button>
              </a-col>
            </a-row>
            <a-row>
              <a-table class="product_table"
                       :locale="{emptyText: '暂无数据'}"
                       :columns="columns"
                       :data-source="testList"
                       :row-key="getRowKey"
                       :pagination="paginationConfig"
                       :row-selection="rowSelection"
              >
                <a slot="name" slot-scope="text">{{ text }}</a>
                 <span slot="action" slot-scope="text, record">
                    <a-popconfirm
                      title='确定删除吗?'
                      @confirm='() => onDelete(record)'
                    >
                       <a href="javascript:;"><a class="product_option">删除</a></a>
                   </a-popconfirm>
                    <a class="product_option" @click="onEdit(record)">编辑</a>
                <!--<a class="product_option">取消爆品</a>-->
                </span>
              </a-table>
            </a-row>
          </div>
        </a-tab-pane>
      </a-tabs>

      <div class="txt_no_support">
        暂不支持移动设备访问，
      </div>
      <div class="txt_no_support">
        请您使用电脑端访问知识库
      </div>
      <!--新增商品和编辑商品的modal-->
      <a-modal
        :visible="modalVisible"
        :confirm-loading="confirmLoading"
        ok-text='保存'
        cancel-text=''
        @ok="handleOk"
        @cancel="handleCancel"
        :closable="true"
        :maskClosable="true"
        class="productModal"
      >
        <template #footer>
          <div style="text-align: center">
            <a-button type="primary" @click="handleOk()" class="btn_query_project btn_now" style="color: black;width: 120px;">保存</a-button>
          </div>
        </template>
        <a-row class="product_modal_title_row"><span class="warnInfo">*</span>产品名称：</a-row>
        <a-row class="product_modal_row">
          <a-input class="input_project_custom project_item" v-model="productItem.name" placeholder="请输入产品名称"/>
          <a-row class="errorInputText" v-if="warnInfo.showName"> {{warnInfo.showNameMsg}} </a-row>
        </a-row>

        <a-row class="product_modal_title_row"><span class="warnInfo">*</span>产品价格：</a-row>
        <a-row class="product_modal_row">
          <a-input class="input_project_custom project_item" v-model="productItem.price" placeholder="请输入产品价格"/>
          <a-row class="errorInputText" v-if="warnInfo.showPrice">{{warnInfo.showPriceMsg}}</a-row>
        </a-row>

        <a-row class="product_modal_title_row"><span class="warnInfo">*</span>产品介绍：</a-row>
        <a-row class="product_modal_row">
          <a-textarea class="input_project_custom"
            v-model="productItem.description"
            placeholder="请输入产品介绍"
            :auto-size="{ minRows: 2, maxRows: 2 }"
          />
          <a-row class="errorInputText" v-if="warnInfo.showDescription"> {{warnInfo.showDescriptionMsg}} </a-row>
        </a-row>

        <a-row class="product_modal_title_row" v-if="false">产品链接：</a-row>
        <a-row class="product_modal_row" v-if="false">
          <a-input class="input_project_custom project_item" v-model="productItem.url" placeholder="请输入产品链接"/>
        </a-row>

        <a-row class="product_modal_title_row"><span class="warnInfo">*</span>引导文案：</a-row>
        <a-row class="product_modal_row">
          <a-input class="input_project_custom project_item" v-model="productItem.comm_tip" placeholder="请输入引导文案"/>
          <a-row class="errorInputText" v-if="warnInfo.showCommTip"> {{warnInfo.showCommTipMsg}} </a-row>
        </a-row>

        <a-row class="product_modal_title_row"><span class="warnInfo">*</span>产品图片（1张）：</a-row>
        <a-row class="product_modal_row">

          <a-upload
            :custom-request="handleCustomRequest"
            :headers="requestHeaders"
            list-type="picture-card"
            :file-list="imageList"
            @change="handleImageChange"
            @preview="handlePreview"
            :before-upload="handleBeforeUploadImage"
            accept=".jpg,.png,.jpeg"
          >
            <div v-if="imageList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                上传
              </div>
            </div>
          </a-upload>
          <a-row class="errorInputText" v-if="warnInfo.showImage"> {{warnInfo.showImageMsg}} </a-row>
           <a-modal :visible="previewVisible" :footer="null" @cancel="handleImageCancel">
            <img alt="example" style="width: 100%" :src="previewImageSrc" />
          </a-modal>
        </a-row>
      </a-modal>
      <!--底部版权声明-->
      <Footer/>
    </div>
  </div>
</template>

<script>
import Footer from './../Footer.vue'
import Header from './HeaderMobile.vue'
import axios from 'axios'
import store from './../../store/store'
import { mapState } from 'vuex'

export default {
  name: 'Base',
  components: {Header, Footer},
  computed: {
    ...mapState(['userAuth', 'project0']),
    showDelete () {
      return this.selectedList.length > 0
    },
    projectId () {
      return this.project0.id
    }
  },
  props: [],
  inject: ['showLogin'],
  watch: {
    userAuth (newValue, oldValue) {
      // 监听 message 数据的变化
      // console.log('New value:', newValue);
      if (!newValue.haveLogin) {
        this.clearList()
      } else {
        this.selectAllProduct()
      }
    },
    projectId (newValue) {
      // 监听 message 数据的变化
      // console.log('projectId New value:', newValue)
      if (newValue > -1) {
        if (this.$store.state.userAuth.haveLogin) {
          this.getArticle()
          this.selectAllProduct()
        }
      } else {
        this.fileContent = ''
      }
    }
  },
  data () {
    return {
      serviceSelected: require('@/assets/icon/service_manager_selected.png'),
      serviceUnSelected: require('@/assets/icon/service_manager_unselected.png'),
      infoSelected: require('@/assets/icon/info_manager_selected.png'),
      infoUnSelected: require('@/assets/icon/info_manager_unselected.png'),
      tabActivity: '0',
      fileList: [
      ],
      fileContent: '',
      baseTip: '想象AI智能体是你新入职的员工或助理。你需要向他们提供公司的基本信息，如业务内容、优势和销售产品，以及必要的行业和专业知识。记住，信息越全面，你的AI智能体表述就越准确。' +
        '不必担心格式，保证信息完整且不冲突即可。如果不能一次填写全面也不必焦虑，你可以随时补充和修改。填写过程中也可参考屏幕右上角的 帮助中心-使用指南 获取灵感。 现在就开始，让你的AI智能体活起来吧！',
      productName: '',
      testList: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: this.renderIndex,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '产品名称',
          dataIndex: 'name'
        },
        {
          title: '价格',
          dataIndex: 'price'
        },
        {
          title: '产品介绍',
          dataIndex: 'description',
          customRender: this.renderDescription
        },
        {
          title: '产品链接',
          dataIndex: 'url',
          customRender: this.renderDescription
        },
        {
          title: '引导文案',
          dataIndex: 'comm_tip',
          customRender: this.renderDescription
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      modalVisible: false,
      showServiceGuideModal: false,
      confirmLoading: false,
      paginationConfig: {
        pageSize: 10
      },
      productDesc: '',
      productItem: {},
      productTemplate: {
        'comm_tip': '',
        'text': '',
        'cover_store_path': '',
        'cover_url': '', // 获取是cover字段
        'cover': '', // 提交是cover字段
        'custom_ids': [], // 引导文案
        'description': '',
        'name': '',
        'price': '',
        'project': this.$store.state.project0.id,
        'project_id': this.$store.state.project0.id,
        'url': ''
      },
      imageList: [], // 产品图片列表
      requestHeaders: {authorization: this.$store.state.userAuth.userToken},
      imageUploadAction: this.$store.state.apiHost + '/api/user/upload_file?file_type=1',
      previewVisible: false,
      previewImageSrc: '',
      warnInfo: {
        showName: false,
        showNameMsg: '请输入产品名称',
        showPrice: false,
        showPriceMsg: '请输入产品价格',
        showDescription: false,
        showDescriptionMsg: '请输入产品介绍',
        showCommTip: false,
        showCommTipMsg: '请输入引导文案',
        showImage: false,
        showImageMsg: '请上传产品图片/视频'
      },
      submitType: 1,
      selectedList: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
          this.selectedList = selectedRows // 将选中的行数据赋值给selectedList
        }
      },
      loadingBase: false // 知识库加载状态 默认不加载
    }
  },
  beforeMount () {
    if (!this.$store.state.isMobile) {
      this.$router.push('/base')
    }
  },
  mounted () {
    this.productItem = JSON.parse(JSON.stringify(this.productTemplate)) // Object.assign({}, this.productTemplate)
    this.selectAllProduct()
    if (this.tabActivity === '0') {
      this.getArticle()
    }
  },
  methods: {
    tabCallback (key) {
      this.tabActivity = key
      if (key === '0') {
        this.getArticle()
      }
    },
    getArticle () {
      // 获取知识库的接口
      if (!this.$store.state.userAuth.haveLogin) {
        this.fileContent = ''
        return
      }
      if (typeof this.$store.state.project0.id === 'undefined') {
        this.$message.error('项目id为空 请重试')
        return
      }
      this.loadingBase = true
      this.$api.getArticle(this.$store.state.project0.id).then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          // 默认项目的知识库
          if (Array.isArray(resData)) {
            if (resData.length > 0) {
              this.fileContent = resData[0].content
            } else {
              this.fileContent = ''
            }
          } else {
            console.log('知识库结果not array')
            this.fileContent = ''
          }
        }
        this.loadingBase = false
      }).catch(error => {
        if (typeof error.data !== 'undefined') {
          let res = error.data
          if (res.msg === 'Token has expired') {
            this.$message.error('登录有效性过期，请退出后重新登录')
          } else {
            this.$message.error('获取云端知识库失败，请重试')
          }
        } else {
          this.$message.error('获取云端知识库失败，请重新登录')
        }
        console.log('error', error)
        this.loadingBase = false
      })
    },
    handleFileChange (info) {
      // 文件状态改变的回调 上传中、完成、失败都会调用这个函数
      console.log('handleFileChange info :', info) // 包含了file 和 fileList
      console.log('handleFileChange fileList:', info.fileList)
      /* if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      } */

      let fileList = [...info.fileList]

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      fileList = fileList.slice(-1)

      // 2. read from response and show file link
      /* fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url
        }
        return file
      }) */

      this.fileList = fileList
    },
    handleBeforeUpload (file) {
      // 预览文件内容
      console.log('file:', file)
      if (file.type === 'text/plain') {
        if (file.size / 1024 < 300) {
          const reader = new FileReader()
          reader.onload = (e) => {
            /* console.log('e', e)
            console.log('target result', e.target.result) */

            this.fileContent = e.target.result
          }
          reader.readAsText(file, 'UTF-8')
        } else {
          this.$message.error('现在内容十万字，文件大小不能超过300K！')
          return false // 阻止文件上传
        }
      } else {
        this.$message.error('请选择一个文本格式的文件！')
        return false // 阻止文件上传
      }
    },
    handleBeforeUploadImage (file) {
      // 预览文件内容
      console.log('image file:', file)
      if (file.size / 1024 / 1024 < 2) {
        return true
      } else {
        return false // 阻止文件上传
      }
    },
    showLoginPanel () {
      if (this.$store.state.isMeuHost) {
        this.$message.error('暂不支持')
      } else {
        this.showLogin()
      }
    },
    getRowKey (record, index) {
      return index // 使用索引作为行的唯一标识
    },
    renderIndex (text, record, index) {
      return index + 1 // 显示序号，从1开始
    },
    renderDescription (text) {
      if (text.length > 15) {
        return `${text.slice(0, 15)}...` // 使用省略号替代超过30个字符的部分
      }
      return text
    },
    customUpload (options) {
      console.log('options:', options)
    },
    uploadFile () {
      // 创建一个 Blob 对象，将文本内容转换为文件
      const blob = new Blob([this.fileContent], { type: 'text/plain' })
      const fileItem = new File([blob], 'upload.txt', { type: 'text/plain' })
      const formData = new FormData()
      formData.append('file', fileItem, fileItem.name)
      formData.append('name', fileItem)
      let token = this.$store.state.userAuth.userToken
      if (token === '' || typeof token === 'undefined' || this.$store.state.project0.id === -1) {
        this.$message.error('请重新登录')
        return
      }
      axios.post(store.state.apiHost + '/api/article/upload/' + this.$store.state.project0.id, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        console.log('response', response)
        if (response.status === 200) {
          console.log('上传成功')
          this.$message.success('上传成功')
          this.fileList[0].status = 'done'
        }
      }).catch(error => {
        // this.$message.error('文件上传失败请重试' + errorMsg)

        // 处理错误的响应
        if (error.response) {
          // 请求已发送，服务器返回了非2xx状态码
          console.log('error.response:', error.response.data)
          this.$message.error(error.response.data.msg)
          // console.log(error.response.status)
          // console.log(error.response.headers)
        } else if (error.request) {
          // 请求已发送但没有收到响应
          console.log('error.request:', error.request)
        } else {
          // 其他错误
          console.log('Error', error.message)
        }
        console.log('Error config：', error.config)
      })
    },
    uploadFileCopy () {
      if (this.fileList.length < 1) {
        this.$message.error('尚未选择文件')
        return
      }
      let fileItem = this.fileList[0].originFileObj
      console.log('fileItem.name：', fileItem.name)
      const formData = new FormData()
      formData.append('file', fileItem, fileItem.name)
      formData.append('name', fileItem)
      let token = this.$store.state.userAuth.userToken
      if (token === '' || typeof token === 'undefined' || this.$store.state.project0.id === -1) {
        this.$message.error('请重新登录')
        return
      }
      axios.post(store.state.apiHost + '/api/article/upload/' + this.$store.state.project0.id, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        console.log('response', response)
        if (response.status === 200) {
          console.log('上传成功')
          this.$message.success('上传成功')
          this.fileList[0].status = 'done'
        }
      }).catch(error => {
        console.log('error', error)
        let errorMsg = ''
        if (error && error.msg) {
          errorMsg = error.msg
        }
        this.$message.error('上传失败请重试' + errorMsg)
      })
    },
    selectAllProduct () {
      let userAuth = this.$store.state.userAuth
      let project0 = this.$store.state.project0
      let phone = userAuth.username
      let projectId = project0.id
      if (projectId > -1) {
        this.$api.getProductList(phone, projectId).then(res => {
          if (res.status === 200) {
            const data = res.data.data
            this.testList = data
          }
        }).catch(error => {
          console.log('query AllProduct error:', error)
        })
      }
    },
    queryProduct () {
      console.log('this.productName:', this.productName)
      if (this.productName === '') {
        this.selectAllProduct()
      } else {
        this.testList = this.testList.filter(t => {
          return t.name.includes(this.productName)
        })
      }
    },
    queryReset () {
      this.productName = ''
      this.selectAllProduct()
    },
    deleteList () {
      /* if (this.selectedList.length === 0) {
        this.$message.error('您没有勾选数据')
      } else {
        this.$message.

      } */
    },
    deleteListSure () {
      if (this.selectedList.length === 0) {
        this.$message.error('您没有勾选数据')
      } else {
        for (let i = 0; i < this.selectedList.length; i++) {
          this.onDelete(this.selectedList[i])
        }
      }
    },
    onDelete (data) {
      if (data.id === '' || typeof data.id === 'undefined' || data.id < 0) {
        console.log('商品id无效，请刷新重试')
        this.$message.error('商品id无效，请刷新重试')
        console.log('data', data)
        return
      }
      this.$api.deleteProduct(data.id).then(res => {
        console.log('res', res)
        if (res.status === 200 || res.status === 'ok') {
          this.$message.success('删除商品成功')
          this.selectAllProduct() // 重新查询产品
        }
      }).catch(error => {
        this.$message.success('删除失败，请刷新重试')
        console.log('error', error)
      })
    },
    clearList () {
      this.testList = []
      this.fileList = []
      this.imageList = []
    },
    onEdit (data) {
      console.log('onEdit', data)
      if (!this.$store.state.userAuth.haveLogin) {
        this.$message.error('尚未登录')
        this.clearList()
        return
      }
      this.initWarnInfo()
      this.productItem = data
      this.productItem.cover = data.cover_url
      this.productItem.project_id = data.project
      this.productItem.text = data.comm_tip
      this.productItem.commodity_id = data.id
      this.previewImageSrc = data.cover_url
      let imageListItem = {
        uid: '1',
        name: 'image.png',
        status: 'done',
        url: data.cover_url
      }
      this.imageList = []
      this.imageList.push(imageListItem)
      this.modalVisible = true
      this.submitType = 2
    },
    addProduct () {
      if (!this.$store.state.userAuth.haveLogin) {
        this.$message.error('尚未登录')
        this.testList = []
        this.fileList = []
        this.imageList = []
        return
      }
      this.modalVisible = true
      this.submitType = 1
      this.productItem = JSON.parse(JSON.stringify(this.productTemplate))
      this.imageList = []
      this.initWarnInfo()
    },
    initWarnInfo () {
      this.warnInfo.showName = false
      this.warnInfo.showPrice = false
      this.warnInfo.showImage = false
      this.warnInfo.showCommTip = false
      this.warnInfo.showDescription = false
    },
    checkWarnInfo () {
      let canUse = true
      if (this.productItem.name === '') {
        this.warnInfo.showName = true
        this.warnInfo.showNameMsg = '请输入产品名称'
        canUse = false
      } else {
        // 校验长度小于16位 中英文 不包含特殊字符
        // eslint-disable-next-line no-inner-declarations
        const validateString = str => {
          // 使用正则表达式进行校验
          const pattern = /^[\u4e00-\u9fa5a-zA-Z0-9]{1,32}$/
          return pattern.test(str)
        }
        const isValid = validateString(this.productItem.name)
        if (!isValid) {
          canUse = false
          this.warnInfo.showName = true
          this.warnInfo.showNameMsg = '产品名称需要小于16位的中英文，但不能包含特殊字符'
        } else {
          this.warnInfo.showName = false
        }
      }
      if (this.productItem.price === '') {
        this.warnInfo.showPrice = true
        this.warnInfo.showNameMsg = '请输入产品价格'
        canUse = false
      } else {
        const validatePrice = str => {
          // 使用正则表达式进行校验
          const pattern = /^\d+(\.\d{1,2})?$/
          return pattern.test(str)
        }
        const isValid = validatePrice(this.productItem.price)
        console.log('isc:', isValid)
        if (!isValid) {
          canUse = false
          this.warnInfo.showPrice = true
          this.warnInfo.showPriceMsg = '产品价格的格式错误，最多保留两位小数'
        } else {
          this.warnInfo.showPrice = false
        }
      }
      if (this.productItem.description === '') {
        this.warnInfo.showDescription = true
        canUse = false
      }
      if (this.productItem.comm_tip === '') {
        this.warnInfo.showCommTip = true
        canUse = false
      }
      if (this.productItem.cover_url === '') {
        this.warnInfo.showImage = true
        canUse = false
      }
      return canUse
    },
    handleOk () {
      // 验证各个输入框值：必填和格式 错误则进行提示
      console.log('handleOk this.productItem:', this.productItem)
      let canUse = this.checkWarnInfo()
      if (!canUse) {
        return
      }
      let item = this.productItem
      item.headers = {Authorization: this.$store.state.userAuth.userToken, 'Content-Type': 'application/json'}
      item.request_type = this.submitType // 1 新增 2更新
      item.text = item.comm_tip
      item.project = this.$store.state.project0.id
      item.project_id = this.$store.state.project0.id
      this.confirmLoading = true
      this.$api.addProduct(item).then(res => {
        // console.log('res:', res)
        if (res.status === 200) {
          this.$message.success('您的数据已在聊天中更新。')
          /* if (this.submitType === 1) {
            this.$message.success('添加产品成功')
          } else {
            this.$message.success('更新产品成功')
          } */
          this.confirmLoading = false
          this.modalVisible = false
          this.selectAllProduct()
        }
      }).catch(error => {
        console.log('error', error)
        this.confirmLoading = false
        this.$message.error('保存失败请重试')
      })
    },
    handleCancel (e) {
      this.modalVisible = false
    },
    showServiceGuide () {
      this.showServiceGuideModal = true
    },
    handleImageCancel (e) {
      this.previewVisible = false
    },
    handleImageChange ({ fileList }) {
      console.log('handleImageChange fileList:', fileList)
      if (fileList.length > 0) {
        if (fileList[0].size / 1024 / 1024 > 2) {
          this.$message.error('上传图片大小不能超过2M！')
          fileList = []
          this.imageList = []
        } else {
          this.imageList = fileList
        }
      } else {
        this.imageList = fileList
      }
    },
    async getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewImageSrc = file.url || file.preview
      this.previewVisible = true
    },
    handleCustomRequest (options) {
      // 上传产品图片
      // 创建一个 FormData 对象
      let fileItem = options.file
      const formData = new FormData()
      formData.append('file', fileItem, fileItem.name)
      formData.append('name', fileItem)
      let token = this.$store.state.userAuth.userToken
      if (token === '' || typeof token === 'undefined') {
        this.$message.error('请重新登录')
        return
      }
      axios.post(this.imageUploadAction, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        // console.log('response', response)
        if (response.status === 200) {
          console.log('上传成功', response.data.data.url)
          this.$message.success('图片上传成功')
          this.imageList[0].status = 'done'
          this.imageList[0].url = response.data.data.url
          this.productItem.cover_url = response.data.data.url
          this.productItem.cover = response.data.data.url
        }
      }).catch(error => {
        console.log('error', error)
        let errorMsg = ''
        if (error && error.msg) {
          errorMsg = error.msg
        }
        this.clearList()
        this.$message.error('上传失败请重试' + errorMsg)
      })
    }
  }
}
</script>

<style lang="less">
.ant-upload-list-item:hover .ant-upload-list-item-info{
  background: none !important;
}
// 加载知识库的加载框
.loadingBaseClass{
  .ant-spin-dot-item{
    background: #28e04a;
  }
}
// 复选框选择背景颜色
.ant-checkbox-checked .ant-checkbox-inner{
  background: #28e04a !important;
  border-color: #28e04a !important;
}
.ant-checkbox:hover .ant-checkbox-input:hover{
  background: #28e04a !important;
  border-color: #28e04a !important;
}
// 复选框 标题框
.ant-checkbox-indeterminate .ant-checkbox-inner::after{
  background: #28e04a !important;
}

.ant-table-tbody > tr.ant-table-row-selected td{
  background: none !important;// 复选框选择背景颜色
}
.ant-tabs-tab {
  color: white;
}
.ant-tabs-tab{
  text-align: left !important;
}
.ant-tabs-nav .ant-tabs-tab-active{
  color: #28E04A !important;
}
.ant-tabs-nav:hover .ant-tabs-tab-active:hover{
  color: #28E04A !important;
}
.ant-tabs-nav .ant-tabs-tab:hover {
  color: white !important;
}
.ant-tabs-ink-bar{
  display: none !important;
  background-color: #28E04A;
}
.ant-tabs-content{
  min-height: 550px;
}
.ant-upload-list-item-info{
  color: white;
}
.ant-upload-list-item-info .anticon-loading, .ant-upload-list-item-info .anticon-paper-clip {
  color: white;
}
.ant-table-thead > tr > th {
  height: 40px !important;
  background: rgba(255,255,255,0.2) !important; // 标题背景颜色
  color: white !important;
  font-size: 16px !important;
  line-height: 16px !important;
  padding: 8px !important;
}
.ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td,.ant-table-row-hover,.ant-table-row-hover>td{
  background: rgb(90, 94, 104) !important;
}

.ant-table-fixed .ant-table-row-hover,.ant-table-row-hover>td{
  background: rgb(90, 94, 104) !important;
}
.ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: rgb(90, 94, 104) !important; // 设置高亮 rgb(90, 94, 104);
}
.ant-table-placeholder{
  background: rgba(255,255,255,0.2) !important; // 没有数据的背景颜色
  color: white !important;
}
/*.ant-table-row-level-0:hover{
  background: red !important; // 会一闪即逝
}*/

.ant-table-tbody > tr > td{
  padding: 8px !important;
}
.ant-table-tbody{
  color: white !important;
}
.custom_tab {
  .ant-tabs-left-content {
    border: 0 !important;
  }
  .hide-divider .ant-tabs-tab {
    border: none !important;
  }
  .ant-tabs-bar .ant-tabs-left-bar{
    border-right: 0 !important;
  }
}
.ant-tabs-bar .ant-tabs-left-bar{
  border-right: 0 !important;
}
.headerRow{
  .input_project_custom{
    width: 178px !important;
    height: 35px !important;
  }
}

.product_modal_row{
  .input_project_custom{
    /*width: 351px !important;
    height: 27px !important;*/
    margin-top: 5px;
    margin-bottom: 5px;
    color: black !important; // #999999
    font-weight: 600;
    text-align: left !important;
  }
  .errorInputText{
    font-size: 12px;
    font-weight: 400;
    color: #FF1D1D;
    line-height: 14px;
    margin-bottom: 10px;
  }
}
.ant-btn-primary {
  background: #28e04a;
  border-color: #28e04a;
}
.productModal{
  .ant-modal-body{
    padding: 20px 48px 0 48px !important;
  }
}
</style>
<style lang="less" scoped>
  .project_name{
    display: inline-block;
    color: white;
    font-size: 18px;
    font-weight: 300;
    line-height: 16px;
    text-align: left;
  }
  .project_item{
    margin-right: 25px;
    text-align: center;
  }
  .btn_query_project{
    width: 77px;
    height: 35px;
    border-radius: 4px;
    font-weight: 400;
    font-size: 18px;
    background: #28E04A;
    border-color: #28E04A;
  }
  .btn_query_project:hover{
    background: rgb(60, 244, 94);
  }
  .custom_tab_panel_title{
    // color: white;
    text-align: right;
    font-size: 20px;
  }
  .headerRow{
    font-size: 18px;
    font-weight: 300;
    color: #FFFFFF;
    line-height: 16px;
    text-align: left;
    padding: 15px 0 0 0;
    margin-bottom: 20px;
  }
  .btn_add_project{
    width: 130px;
    height: 35px;
    border-radius: 4px;
    font-weight: 400;
    font-size: 18px;
    background: #28E04A;
    border-color: #28E04A;
  }
  .btn_add_project:hover{
    background: rgb(60, 244, 94);
  }
  .custom_tab{
    padding-left: 135px;
    padding-right: 135px;
    .ant-tabs-left-content{
      border: 0;
    }
    .hide-divider .ant-tabs-tab {
      border: none;
    }
    .serviceInfoManage{
      font-size: 20px;
      font-weight: 400;
      color: rgba(255,255,255,0.8);
      line-height: 23px;
      background-color: #313642;
      padding: 0 38px 10px 38px;
      border-radius: 4px;
      min-height: 550px;
      .btn_upload{
        width: 120px;
        height: 40px;
        font-size: 16px;
        font-weight: 400;
      }
      /deep/ .btn_upload:hover{
        color: black;
        border: 0;
      }
      /deep/ .btn_now{
        height: 40px;
        font-weight: 400;
        background: #28E04A;
        border-radius: 4px 4px 4px 4px;
        border-color: #28E04A;
        opacity: 1;
        font-size: 16px;
        color: #000c17;
      }
      .serviceInfoManageTitle{
        font-size: 22px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 33px;
        padding: 18px 0 15px 0;
        text-align: center;
        background-color: #313642;
      }
      .custom_textarea{
        background: none;
        border-color:  rgba(153,153,153,0.5);
        color: rgba(255,255,255,0.8);
        margin-bottom: 10px;

        scrollbar-width: thin;
        scrollbar-color: #999999 #f5f5f5;
      }
      .custom_textarea::-webkit-scrollbar {
        width: 8px;
      }

      .custom_textarea::-webkit-scrollbar-track {
        background-color: #f5f5f5;
      }

      .custom_textarea::-webkit-scrollbar-thumb {
        background-color: #999999;
        border-radius: 4px;
      }

      .custom_textarea::-webkit-scrollbar-thumb:hover {
        background-color: #888888;
      }
    }

    .productManage{
      font-size: 20px;
      font-weight: 400;
      color: rgba(255,255,255,0.8);
      line-height: 23px;
      background-color: #313642;
      padding: 0 38px 10px 38px;
      border-radius: 4px;
      min-height: 550px;
      .headerRow{
        font-size: 18px;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 16px;
        text-align: left;
        background-color: #313642;
        padding: 15px 0 0 0;
        margin-bottom: 20px;
      }
      .project_item{
        margin-right: 25px;
      }
      /*.project_item:hover{
        background: rgb(60, 244, 94);
        color: #000c17;
      }*/
      .project_name{
        display: inline-block;
        color: white;
      }
      .btn_reset_project{
        width: 77px;
        height: 35px;
        border-radius: 4px;
        opacity: 1;
        font-weight: 400;
        font-size: 18px;
      }
      .btn_add_project{
        width: 130px;
        height: 35px;
        border-radius: 4px;
        font-weight: 400;
        font-size: 18px;
        background: #28E04A;
        border-color: #28E04A;
      }
      .btn_add_project:hover{
        background: rgb(60, 244, 94);
      }
      .product_table{
        .product_option{
          color: #28E04A;
          font-size: 14px;
          font-weight: 400;
          color: #28E04A;
          line-height: 14px;
        }
      }

    }
  }
  .product_modal_title_row{
    font-size: 16px;
    font-weight: 500;
    color: black;
    .warnInfo{
      color: red;
    }
  }
  .serviceGuideModal{
    ant-modal-body{
      padding-bottom: 10px;
    }
  }
  .txt_no_support{
    width: 100%;
    padding: 30px 20px 0 20px;
    font-size: 20px;
    font-weight: 500;
    color: #28E04A;
    line-height: 23px;
    letter-spacing: 1.5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/BaseMobile.vue